import React from 'react'
import { StaticImage } from "gatsby-plugin-image";

const BlackCollar = () => {
  return (
    <StaticImage
    placeholder="blurred"
    src="../../../../../../../images/collar-perro-kolyy-gps.png"
    alt="collar inteligente kolyy"
  />
  )
}

export default BlackCollar